import { cn } from "@omni/utils/styles";

import { Card } from "@/components/General/Card/card.component";
import { CardBody } from "@/components/General/Card/cardBody.component";
import { CardTitle } from "@/components/General/Card/cardTitle.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    balance: number;
};

const BonusCardBalance = ({ balance }: Props) => {
    const { t } = useGranite();
    return (
        <Card>
            <CardBody>
                <CardTitle tag="h2">
                    {t("general.bonusCardRequestBalance.title")}
                </CardTitle>
                <span>{t("general.bonusCardRequestBalance.balance")}: </span>
                <span className={cn("tw:font-bold tw:text-danger tw:text-lg")}>
                    {balance}
                </span>
            </CardBody>
        </Card>
    );
};

export default BonusCardBalance;
